import { gql } from "@apollo/client";
import { dxpClient } from "./apollo-client";
import { cp } from "fs";
import { fetchAllData } from "./fetchAllData";

// New query for fetching academy data for search
export const SEARCH_ACADEMY_QUERY = `
  query SearchAcademy($skip: Int) {
    cAAcademyCollection(take: 100, skip: $skip) {
      items {
        headline
        description
        _system {
          contentType
          lastPublished
          id
        }
      }
    }
  }
`;

// New query for fetching contact information for search
export const SEARCH_CONTACT_INFORMATION_QUERY = `
  query SearchContactInfo($skip: Int) {
    cAContactInfoCollection(take: 100, skip: $skip) {
      items {
        name
        title
        email
        phoneNumber
        _system {
          contentType
          lastPublished
          id
        }
      }
    }
  }
`;

// New query for fetching group records for search
export const SEARCH_GROUP_RECORD_QUERY = `
  query SearchGroupName($skip: Int) {
    cAGroupNameCollection(take: 100, skip: $skip) {
      items {
        title
        _system {
          contentType
          lastPublished
          id
        }
      }
    }
  }
`;

// New query for fetching resources for search
export const SEARCH_RESOURCE_RECORD_QUERY = `
  query SearchResources($skip: Int) {
    cAResourcesCollection(take: 100, skip: $skip) {
      items {
        title
        shortDescription
        buttonURL
        aliasPath
        _system {
          lastPublished
          id
          contentType
        }
        groupName
        resourceType
      }
    }
  }
`;

export const RESOURCE_TYPE_QUERY = `
  query CAResourceTypeCollection($skip: Int) {
    cAResourceTypeCollection(take: 100, skip: $skip) {
      items {
        title
        _system {
          contentType
          id
        }
      }
    }
  }
`;

export const RESOURCE_ASSET_QUERY = `
  query CAResourceAssetCollection($skip: Int) {
    cAResourceAssetCollection(take: 100, skip: $skip) {
      items {
        _system {
          contentType
          lastPublished
          id
        }
        title
        imageContentHub {
          items {
            contentFile {
              name
              path
              fileSize
              fileType
              width
              height
            }
          }
        }
        resource
      }
    }
  }
`;

//Announcement
export const Announcement_QUERY = `
  query CAAnnouncementsCollection($skip: Int) {
    cAAnnouncementsCollection(take: 100, skip: $skip) {
      items {
        headline
        message
        endDate
        _system {
          id
          contentType
          lastPublished
        }
      }
    }
  }
`;

// New query for fetching key dates data for search
export const SEARCH_KEY_DATES_QUERY = `
  query CAKeyDatesCollection($skip: Int) {
    cAKeyDatesCollection(take: 100, skip: $skip) {
      items {
        _system {
          id
          contentType
          lastPublished
        }
        headline
        description
        endDate
      }
    }
  }
`;

// Function to index data for faster search
const indexData = (data: any[]) => {
  INDEXED_DATA.clear();
  const currentDate = new Date();
  const filteredData = data.filter((item) => {
    if (item.__typename === "CAAnnouncements" && item.endDate) {
      return new Date(item.endDate) >= currentDate;
    }
    if (item.__typename === "CAKeyDates" && item.endDate) {
      return new Date(item.endDate) >= currentDate;
    }
    return true;
  });

  filteredData.forEach((item) => {
    const keywords = [
      item.headline,
      item.description,
      item.message,
      item.shortDescription,
      item.title,
      item.name,
      item.email,
      ...(item.imageContentHub?.items?.map(
        (contentFile: { name: string }) => contentFile.name
      ) || []),
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .split(" ");

    keywords.forEach((keyword) => {
      if (!INDEXED_DATA.has(keyword)) {
        INDEXED_DATA.set(keyword, []);
      }
      const keywordItems = INDEXED_DATA.get(keyword);
      if (keywordItems) {
        keywordItems.push(item);
      }
    });
  });
};

const cache = new Map();
const INDEXED_DATA = new Map<string, any[]>();
let didFetch = false;

export const fetchDataAndIndex = async () => {
  if (didFetch) return;
  didFetch = true;
  try {
    // const academyResults = await dxpClient
    //   .query({
    //     query: SEARCH_ACADEMY_QUERY,
    //   })
    //   .catch((error) => {
    //     console.warn("SearchAcademy content type does not exist:", error);
    //     return { data: { cAAcademyCollection: { items: [] } } };
    //   });
    const academyResults = await fetchAllData(
      SEARCH_ACADEMY_QUERY,
      {},
      "cAAcademyCollection"
    ).catch((error) => {
      console.warn("SearchAcademy content type does not exist:", error);
      return [];
    });
    //console.log('academyResults', academyResults);

    // const announcementResults = await dxpClient
    //   .query({
    //     query: Announcement_QUERY,
    //   })
    const announcementResults = await fetchAllData(
      Announcement_QUERY,
      {},
      "cAAnnouncementsCollection"
    ).catch((error) => {
      console.warn(
        "cAAnnouncementsCollection content type does not exist:",
        error
      );
      return [];
    });
    //console.log('announcementResults', announcementResults);

    // const groupResults = await dxpClient
    //   .query({
    //     query: SEARCH_GROUP_RECORD_QUERY,
    //   })
    const groupResults = await fetchAllData(
      SEARCH_GROUP_RECORD_QUERY,
      {},
      "cAGroupNameCollection"
    ).catch((error) => {
      console.warn("SearchGroupName content type does not exist:", error);
      return [];
    });

    //console.log('groupResults', groupResults);

    // const resourceTypeResults = await dxpClient
    //   .query({
    //     query: RESOURCE_TYPE_QUERY,
    //   })
    const resourceTypeResults = await fetchAllData(
      RESOURCE_TYPE_QUERY,
      {},
      "cAResourceTypeCollection"
    ).catch((error) => {
      console.warn("SearchResourceType content type does not exist:", error);
      return [];
    });
    //console.log('resourceTypeResults', resourceTypeResults);

    // const resourceResults = await dxpClient
    //   .query({
    //     query: SEARCH_RESOURCE_RECORD_QUERY,
    //   })
    const resourceResults = await fetchAllData(
      SEARCH_RESOURCE_RECORD_QUERY,
      {},
      "cAResourcesCollection"
    ).catch((error) => {
      console.warn("SearchResources content type does not exist:", error);
      return [];
    });
    //console.log('resourceResults', resourceResults);

    // const documentResults = await dxpClient
    //   .query({
    //     query: RESOURCE_ASSET_QUERY,
    //   })
    const documentResults = await fetchAllData(
      RESOURCE_ASSET_QUERY,
      {},
      "cAResourceAssetCollection"
    ).catch((error) => {
      console.warn(
        "cAResourceAssetCollection content type does not exist:",
        error
      );
      return [];
    });
    //console.log('documentResults', documentResults);

    // const contactInfoResults = await dxpClient
    //   .query({
    //     query: SEARCH_CONTACT_INFORMATION_QUERY,
    //   })
    const contactInfoResults = await fetchAllData(
      SEARCH_CONTACT_INFORMATION_QUERY,
      {},
      "cAContactInfoCollection"
    ).catch((error) => {
      console.warn(
        "cAContactInfoCollection content type does not exist:",
        error
      );
      return [];
    });
    //console.log('contactInfoResults', contactInfoResults);

    // const keyDatesResults = await dxpClient
    //   .query({
    //     query: SEARCH_KEY_DATES_QUERY,
    //   })
    const keyDatesResults = await fetchAllData(
      SEARCH_KEY_DATES_QUERY,
      {},
      "cAKeyDatesCollection"
    ).catch((error) => {
      console.warn("CAKeyDatesCollection content type does not exist:", error);
      return [];
    });
    //console.log('keyDatesResults', keyDatesResults);

    const groupMap = new Map(
      groupResults.map((group: { _system: { id: string }; title: string }) => [
        group._system.id,
        group.title,
      ])
    );

    const resourcetypeMap = new Map(
      resourceTypeResults.map(
        (resourceType: { _system: { id: string }; title: string }) => [
          resourceType._system.id,
          resourceType.title,
        ]
      )
    );

    // groupName is stored as a JSON map {"resourceTypeId": ["groupId1","groupId2"]}
    // or a plain comma-separated GUID string after the backend refactor.
    const resolveGroupName = (raw: string): string => {
      if (!raw) return "";
      try {
        const parsed = JSON.parse(raw);
        if (typeof parsed === "object" && parsed !== null && !Array.isArray(parsed)) {
          const groupIds: string[] = [];
          Object.values(parsed).forEach((arr: any) => {
            if (Array.isArray(arr)) arr.forEach((id: string) => groupIds.push(id));
          });
          const names = Array.from(new Set(groupIds))
            .map((id) => groupMap.get(id))
            .filter(Boolean);
          return (names[0] as string) || "";
        }
      } catch {
        // not JSON – fall through
      }
      const ids = raw.split(",").map((id) => id.trim());
      const names = ids.map((id) => groupMap.get(id)).filter(Boolean);
      return (names[0] as string) || "";
    };

    // resourceType is stored as a comma-separated string of UUIDs.
    const resolveResourceType = (raw: string): string => {
      if (!raw) return "";
      const ids = raw.split(",").map((id) => id.trim());
      const names = ids.map((id) => resourcetypeMap.get(id)).filter(Boolean);
      return (names[0] as string) || "";
    };

    const resourcemap = new Map<
      string,
      { title: string; groupName: string; aliasPath?: string }
    >(
      resourceResults.map(
        (resource: {
          _system: { id: string };
          title: string;
          groupName: string;
          aliasPath?: string;
        }) => [
            resource._system.id,
            {
              title: resource.title,
              groupName: resolveGroupName(resource.groupName),
              aliasPath: resource.aliasPath,
            },
          ]
      ) || []
    );

    const allResults = [
      ...(academyResults || []),
      ...(announcementResults || []),
      ...(resourceResults
        .map((item: any) => ({
          ...item,
          groupName: resolveGroupName(item.groupName),
          resourceType: resolveResourceType(item.resourceType),
        }))
        .filter((item: any) => item.groupName) || []),
      ...(documentResults.map((item: any) => ({
        ...item,
        resourceTitle: resourcemap.get(item.resource)?.title,
        resourceGroupName: resourcemap.get(item.resource)?.groupName,
        aliasPath: resourcemap.get(item.resource)?.aliasPath,
      })) || []),
      ...(contactInfoResults || []),
      ...(keyDatesResults || []),
    ];
    didFetch = false;

    //console.log('allResults', allResults);
    // Index the data for faster search
    indexData(allResults);

    // Clear the cache to ensure it is updated with new data
    cache.clear();
  } catch (error) {
    console.info("Error fetching and indexing data:", error);
  }
};

// // Fetch and index data initially
// fetchDataAndIndex();

// Set an interval to periodically re-fetch and re-index data
setInterval(fetchDataAndIndex, 3600000); // Re-fetch and re-index every hour

export const performSearch = async (keyword: string) => {
  try {
    if (cache.has(keyword)) {
      return cache.get(keyword);
    }

    const sanitizedKeyword = keyword
      .replace(/[^\w\s]/g, "") // Remove special characters
      .toLowerCase();
    const keywords = sanitizedKeyword.split(" ").filter((kw) => kw.length >= 3);

    const filteredResults = Array.from(INDEXED_DATA.entries())
      .filter(([key]) => keywords.some((kw) => key.includes(kw)))
      .flatMap(([, items]) => items);

    // Deduplicate based on the `title` or `headline`
    const uniqueFilteredResults = Array.from(
      new Set(filteredResults.map((a) => a.title || a.headline))
    ).map((titleOrHeadline) =>
      filteredResults.find((a) => (a.title || a.headline) === titleOrHeadline)
    );

    // Rank results based on the number of matching words
    const rankedResults = uniqueFilteredResults
      .map((result) => {
        const matchCount = keywords.reduce((count, kw) => {
          return (
            count +
            (result.title?.toLowerCase().includes(kw) ||
              result.headline?.toLowerCase().includes(kw)
              ? 1
              : 0)
          );
        }, 0);
        return { result, matchCount };
      })
      .sort((a, b) => b.matchCount - a.matchCount)
      .map((item) => item.result);

    if (rankedResults.length === 0) {
      return [];
    }

    cache.set(keyword, rankedResults);
    return rankedResults;
  } catch (error) {
    console.info("Error performing search:", error);
    throw error;
  }
};
